import { Injectable } from 'ng-metadata/core';
import {getShowICPLicenseFooter} from '../appConfig/appConfigForward';

@Injectable()
export class PrimoExploreFooterService {

    public get showICPLicenseFooter(){
        let showICPLicenseFooter = false;
        let showICPLicenseFooterValue = getShowICPLicenseFooter();
        if (showICPLicenseFooterValue
            && (showICPLicenseFooterValue.toLowerCase() === 'yes' || showICPLicenseFooterValue.toLowerCase() === 'true')) { 
            showICPLicenseFooter = true;
        }
        return showICPLicenseFooter;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/primoExploreFooter.service.ts